export function formatHypothesisTitle(value) {
    return value.replace(/[«»]/g, '').replace(/\s{2,}/g, ' ').trim();
}
//# sourceMappingURL=titles.js.map